import { Heading } from 'components/text';
import style from './AdditionalNote.module.scss';
import cx from 'classnames';
import HtmlViewer from 'components/html-viewer';

type AdditionalNoteProps = {
  className?: string;
  additionalNote?: {
    title?: string;
    description?: string;
  };
};

const AdditionalNote = ({ additionalNote, className }: AdditionalNoteProps) => {
  const { title, description } = additionalNote || {};
  if (!title && !description) {
    return null;
  }
  return (
    <div className={cx(style.container, className)}>
      {title && <Heading as="h5">{title}</Heading>}
      {description && <HtmlViewer content={description} />}
    </div>
  );
};

export default AdditionalNote;
